module.exports = __webpack_public_path__ + "static/media/process.7845ccc9.jpg";